import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";
import { Calendar } from "lucide-react";
import NotificationDropdown from "./NotificationDropdown";

export default function OperatorHeader() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);

  const initials = user?.email?.slice(0, 2).toUpperCase() || "??";
  const displayName =
    user?.user_metadata?.display_name || user?.email?.split("@")[0] || "Operator";

  const locale = i18n.language.startsWith("de") ? "de-DE" : i18n.language.startsWith("nl") ? "nl-NL" : i18n.language.startsWith("fr") ? "fr-FR" : i18n.language.startsWith("pl") ? "pl-PL" : "en-GB";

  const dateStr = now.toLocaleDateString(locale, {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const timeStr = now.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });

  const clockSuffix = t("opHeader.clockSuffix");

  return (
    <header className="h-14 border-b border-border bg-card flex items-center justify-between px-6">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Calendar className="w-4 h-4" />
        <span>{dateStr}</span>
        <span className="text-border">|</span>
        <span>{timeStr}{clockSuffix ? ` ${clockSuffix}` : ""}</span>
      </div>

      <div className="flex items-center gap-4">
        <NotificationDropdown />
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-medium">
            {initials}
          </div>
          <span className="text-sm text-foreground hidden lg:block">{displayName}</span>
        </div>
      </div>
    </header>
  );
}
